"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EngineState;
(function (EngineState) {
    EngineState["SRC_SET"] = "engine-state/src-set";
    EngineState["LOAD_STARTED"] = "engine-state/load-started";
    EngineState["METADATA_LOADED"] = "engine-state/metadata-loaded";
    EngineState["READY_TO_PLAY"] = "engine-state/ready-to-play";
    EngineState["SEEK_IN_PROGRESS"] = "engine-state/seek-in-progress";
    EngineState["PLAY_REQUESTED"] = "engine-state/play-requested";
    EngineState["WAITING"] = "engine-state/waiting";
    EngineState["PLAYING"] = "engine-state/playing";
    EngineState["PAUSED"] = "engine-state/paused";
    EngineState["ENDED"] = "engine-state/ended";
})(EngineState || (EngineState = {}));
exports.default = EngineState;
//# sourceMappingURL=engine-state.js.map